export const ssr = true
export const prerender = true
export const trailingSlash = 'always'
